/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Field_Read_OnlyInputs */

const en_error_field_read_only = /** @type {(inputs: Error_Field_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can see these fields but not change them.`)
};

/**
* | output |
* | --- |
* | "You can see these fields but not change them." |
*
* @param {Error_Field_Read_OnlyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_field_read_only = /** @type {((inputs?: Error_Field_Read_OnlyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Field_Read_OnlyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_field_read_only(inputs)
});